<template>
  <div class="">
    <el-dialog :visible.sync="isVisible" title="修改密码" :close-on-click-modal="false"
       :modal-append-to-body="false" width="40%" @close="closeDialog"
    >
      <div>
        <el-form ref="formRef" :model="form" :rules="rules" label-width="120px">
          <el-form-item label="登录名称">
            <el-input v-model.trim="form.loginName"></el-input>
          </el-form-item>
          <el-form-item label="旧密码" prop="oldPassword">
            <el-input type="password" v-model.trim="form.oldPassword" show-password autocomplete="new-password0"></el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="newPassword">
            <el-input type="password" v-model.trim="form.newPassword" show-password autocomplete="new-password"></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="confirmPassword">
            <el-input type="password" v-model.trim="form.confirmPassword" show-password autocomplete="new-password1"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div style="margin: 20px 0;text-align: right;">
        <el-button @click="closeDialog" :disabled="submitLoading">取 消</el-button>
        <el-button type="primary" @click="submit" :loading="submitLoading" :disabled="submitLoading">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: '',
  data() {
    return {
      isVisible: this.dialogRow.show,
      form: {
        loginName: '',
        oldPassword: '',
        newPassword: '',
        confirmPassword: '',
      },
      submitLoading: false,
      rules: {
        oldPassword: [{ required: true, message: '请输入密码', trigger: "blur" }],
        newPassword: [
          { required: true, message: '请输入密码', trigger: "blur" },
          { min: 4, max: 20, message: '长度在4~20以内', trigger: "blur" },
        ],
        confirmPassword: [
          { required: true, validator: this.validatePass, trigger: 'blur' }
        ]
      }
    }
  },
  props: {
    dialogRow: {
      type: Object,
    }
  },
  mounted() {
    this.form.loginName = this.dialogRow.data.accountName || '';
  },
  methods: {
    validatePass(rule, value, callback) {
      if (value === '') {
        callback('请再次确实新密码')
      } else {
        if(this.form.newPassword !== this.form.confirmPassword) {
          callback('两次密码不一致');
        }
        callback()
      }
    },
    async submit() {
      this.$refs['formRef'].validate(async (valid) => {
        if(valid) {
          const data = Object.assign({}, this.form);
          this.submitLoading = true;
          const request = axios.create({
            baseURL: 'http://monitor.szdatie.com:10211/'
          })
          // request拦截器
          request.interceptors.request.use(config => {
            config.headers.token = sessionStorage.getItem('TOKEN');
            return config
          }, error => {
            Promise.reject(error)
          })
          const res = await request.post('/api/v1/idsvc/account/password/update', data).catch((err => {
            this.$message.error(err.response.data.msg);
          })).finally(() => this.submitLoading = false);

          if(res.data.code === 0) {
            this.$message.success('修改密码成功，三秒后即将退出登录！');
            this.$emit('closeEditPasswordDialog', true);
          }
        }
      })
    },
    closeDialog() {
      this.$emit('closeEditPasswordDialog');
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/main/account/components/editPassWordDialog.vue